import httpWrapper from '../HttpWrapper'
import { ImportEventDto } from './models/ImportEventDto'

class DataImportApi {
    private static instance: DataImportApi

    public constructor() {
        if (DataImportApi.instance) {
            return DataImportApi.instance
        }

        DataImportApi.instance = this
    }

    public async importCsv(formData: FormData): Promise<void> {
        await httpWrapper.post('/data-import/csv-upload', formData, undefined, {
            timeout: 600000, // 10 mins
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    }

    public async verifyCsv(formData: FormData): Promise<void> {
        await httpWrapper.post('/data-import/csv-verify', formData, undefined, {
            timeout: 600000, // 10 mins
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    }

    public async deleteAll(): Promise<void> {
        await httpWrapper.post('/data-import/delete-all')
    }

    public async getNumberOfImportEventNodes(): Promise<number> {
        return await httpWrapper.get('/data-import/count')
    }

    public async getLastImportEvent(): Promise<ImportEventDto> {
        return await httpWrapper.get('/data-import/last-import')
    }
}

const dataImportApi = new DataImportApi()
export default dataImportApi
